(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('features-carousel')) {
    customElements.define(
      'features-carousel',
      class FeaturesCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dotsEl = this.querySelector('[data-dots]');
          this.items = Array.from(this.querySelectorAll('[data-item]'));
          if (!this.track || this.items.length < 2) return;

          this.index = 0;
          this.timer = null;
          this.resumeTimer = null;
          this.delay = parseInt(this.dataset.autoplay || '0', 10);
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.onScroll = this.debounce(() => this.syncFromScroll(), 80);
          this.onPointer = () => this.pauseTemporarily();
          this.onVisibility = () => (document.hidden ? this.stop() : this.maybeStart());
          this.onResize = this.debounce(() => this.refresh(), 200);

          this.buildDots();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('pointerdown', this.onPointer, { passive: true });
          this.track.addEventListener('touchstart', this.onPointer, { passive: true });
          document.addEventListener('visibilitychange', this.onVisibility);
          window.addEventListener('resize', this.onResize);

          // Only run autoplay while the section is on screen.
          this.observer = new IntersectionObserver(
            (entries) => {
              this.visible = entries[0].isIntersecting;
              this.visible ? this.maybeStart() : this.stop();
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);

          this.refresh();
        }

        disconnectedCallback() {
          this.stop();
          clearTimeout(this.resumeTimer);
          this.observer?.disconnect();
          this.track?.removeEventListener('scroll', this.onScroll);
          this.track?.removeEventListener('pointerdown', this.onPointer);
          this.track?.removeEventListener('touchstart', this.onPointer);
          document.removeEventListener('visibilitychange', this.onVisibility);
          window.removeEventListener('resize', this.onResize);
        }

        debounce(fn, wait) {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        }

        /* True only when the track is genuinely a scroller (mobile).
           On the desktop grid this is false, so dots + autoplay switch off
           without hardcoding breakpoints in JS. */
        get scrollable() {
          return this.track.scrollWidth - this.track.clientWidth > 4;
        }

        buildDots() {
          if (!this.dotsEl) return;
          this.dotsEl.innerHTML = '';
          this.items.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'features-strip__dot';
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            dot.addEventListener('click', () => {
              this.pauseTemporarily();
              this.goTo(i);
            });
            this.dotsEl.appendChild(dot);
          });
        }

        updateDots() {
          if (!this.dotsEl) return;
          Array.from(this.dotsEl.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          });
        }

        goTo(i, behavior) {
          this.index = (i + this.items.length) % this.items.length;
          const left = this.items[this.index].offsetLeft - this.items[0].offsetLeft;
          this.track.scrollTo({
            left,
            behavior: behavior || (this.reduced.matches ? 'auto' : 'smooth'),
          });
          this.updateDots();
        }

        syncFromScroll() {
          if (!this.scrollable) return;
          const origin = this.items[0].offsetLeft;
          const pos = this.track.scrollLeft;
          let nearest = 0;
          let best = Infinity;
          this.items.forEach((item, i) => {
            const d = Math.abs(item.offsetLeft - origin - pos);
            if (d < best) {
              best = d;
              nearest = i;
            }
          });
          if (nearest !== this.index) {
            this.index = nearest;
            this.updateDots();
          }
        }

        refresh() {
          const on = this.scrollable;
          if (this.dotsEl) this.dotsEl.hidden = !on;
          if (on) {
            this.syncFromScroll();
            this.maybeStart();
          } else {
            this.stop();
          }
        }

        maybeStart() {
          this.stop();
          if (!this.delay || !this.scrollable || !this.visible || document.hidden) return;
          if (this.reduced.matches) return;
          this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        pauseTemporarily() {
          this.stop();
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => this.maybeStart(), 4000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
